export const SET_USER = 'current-user/set-user';
export const UNSET_USER = 'current-user/unset-user';
export const SET_HEADER_STATUS = 'current-user/header-status';
export const SET_SETTINGS_DATA = 'current-user/set-settings-data';
export const SET_EXTRA_DATA = 'current-user/set-extra-data';
export const SET_CLIENT_DATA = 'current-user/set-client-data';
